import { render } from "./Back.vue?vue&type=template&id=1f814b84&scoped=true"
import script from "./Back.vue?vue&type=script&lang=js"
export * from "./Back.vue?vue&type=script&lang=js"

import "./Back.vue?vue&type=style&index=0&id=1f814b84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f814b84"]])

export default __exports__